class Hero {
  #id = null;

  #name = 'LEMON_NOT_FOUND';

  #intelligence = 0;

  #strength = 0;

  #stamina = 0;

  #agility = 0;

  #luck = 0;

  #spriteSheet = '';

  #attackType = '';

  #team = '';

  #baseHp;

  static MAX_ATTRIBUTES_POINTS = 350;

  constructor({
    id,
    name,
    intelligence,
    strength,
    stamina,
    agility,
    luck,
    spriteSheet,
    attackType,
    team,
  }) {
    this.#id = id;
    this.#name = name;
    this.#intelligence = intelligence;
    this.#strength = strength;
    this.#stamina = stamina;
    this.#agility = agility;
    this.#luck = luck;
    this.#spriteSheet = spriteSheet;
    this.#attackType = attackType;
    this.#team = team;
    this.#baseHp = this.#initialHp();

    this.#validate();
  }

  #validate() {
    if (this.totalAttributes > this.MAX_ATTRIBUTES_POINTS) {
      throw new Error('Invalid attributes');
    }
  }

  // NOTE: getter

  #initialHp() {
    return this.#strength * 1;
  }

  get id() {
    return this.#id;
  }

  get totalAttributes() {
    return (
      this.#agility +
      this.#stamina +
      this.#strength +
      this.#intelligence +
      this.#luck
    );
  }

  get baseCriticalHitChance() {
    return this.#luckCriticalHitChance();
  }

  get baseApplyEffectChance() {
    return this.#luckApplyEffectChance();
  }

  get baseImmuneEffectChance() {
    return this.#staminaImmuneEffectChance();
  }

  get baseMovementRange() {
    return this.#agilityMovementRange();
  }

  get baseEvadePhysicalDamageChance() {
    return this.#agilityEvadePhysicalDamageChance();
  }

  get baseEvadeElementalDamageChance() {
    return this.#luckEvadeElementalDamageChance();
  }

  get baseIncreasePhysicalDamage() {
    return this.#strengthIncreasePhysicalDamage();
  }

  get baseReducePhysicalDamage() {
    return this.#strengthReducePhysicalDamage();
  }

  get baseIncreaseElementalDamage() {
    return this.#intelligenceIncreaseElementalDamage();
  }

  get baseReduceElementalDamage() {
    return this.#intelligenceReduceElementalDamage();
  }

  serialize() {
    return {
      id: this.#id,
      name: this.#name,
      strength: this.#strength,
      stamina: this.#stamina,
      agility: this.#agility,
      intelligence: this.#intelligence,
      baseCriticalHitChance: this.baseCriticalHitChance,
      baseApplyEffectChance: this.baseApplyEffectChance,
      baseImmuneEffectChance: this.baseImmuneEffectChance,
      baseMovementRange: this.baseMovementRange,
      baseEvadePhysicalDamageChance: this.baseEvadePhysicalDamageChance,
      baseEvadeElementalDamageChance: this.baseEvadeElementalDamageChance,
      baseIncreasePhysicalDamage: this.baseIncreasePhysicalDamage,
      baseReducePhysicalDamage: this.baseReducePhysicalDamage,
      baseIncreaseElementalDamage: this.baseIncreaseElementalDamage,
      baseReduceElementalDamage: this.baseReduceElementalDamage,
      baseHp: this.#baseHp,
      spriteSheet: this.#spriteSheet,
      attackType: this.#attackType,
      team: this.#team,
      // TODO: remove followings
      orderStrength: 6,
      movingRange: 2,
    };
  }

  // private

  // NOTE: strength effect

  #strengthIncreasePhysicalDamage() {
    return 1 + (this.#strength * 0.25) / 100;
  }

  #strengthReducePhysicalDamage() {
    return 1 + (this.#strength * 0.2) / 100;
  }

  // NOTE: intelligence effect
  #intelligenceIncreaseElementalDamage() {
    return 1 + (this.#intelligence * 0.25) / 100;
  }

  #intelligenceReduceElementalDamage() {
    return 1 + (this.#intelligence * 0.2) / 100;
  }

  // NOTE: agility effect

  #agilityMovementRange() {
    return Math.round(1 + this.#agility * 0.04);
  }

  #agilityEvadePhysicalDamageChance() {
    return Math.round(1 + this.#agility * 0.04);
  }

  // NOTE: stamina effect

  #staminaImmuneEffectChance() {
    return this.#stamina * 0.3;
  }

  // NOTE: luck effect
  #luckCriticalHitChance() {
    return this.#luck * 0.6;
  }

  #luckApplyEffectChance() {
    return this.#luck * 0.3;
  }

  #luckEvadeElementalDamageChance() {
    return this.#luck * 0.2;
  }
}

export default Hero;
